/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum UserStatus {
    UNVERIFIED = 'Unverified',
    VERIFIED = 'Verified',
    PROFILED = 'Profiled',
    PENDING = 'Pending',
    ACTIVE = 'Active',
    INACTIVE = 'Inactive',
    COMPROMISED = 'Compromised',
    CANCELLED = 'Cancelled',
}
